import { state, update } from 'bey-fix'

import { updateLoggedInUser } from '../helpers/api'

const user = state({
  id: null,
  name: null,
  email: null,
})

export const setUser = ({ id, name, email }) =>
  update(user, (state) => ({ id, name, email }))

export const updateUserName = (name) =>
  update(user, (state) => {
    if (name) {
      state.name = name
    }
  })

export async function persistUserName(userId, name) {
  // Optimistically update UI
  updateUserName(name)

  // Persist through API
  const updatedUser = await updateLoggedInUser({ userId, name })
  if (updatedUser) {
    setUser(updatedUser)
  }
}

export const updateUserEmail = (email) =>
  update(user, (state) => {
    if (email) {
      state.email = email
    }
  })

export default user
